import React from "react";
import style from "./discountCard.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import numberWithCommas from "../../../helpers/actions/numberWithCommas";
import moment from "moment-jalaali";

const packagesDic = {
    'bronze': 'برنزی',
    'silver': 'نقره‌ای',
    'gold': 'طلایی',
    'platine': 'پلاتینیوم'
}
const packagesNames = (packages) => {
    let tempStr = ''
    packages.forEach((item, index) => {
        tempStr = tempStr + packagesDic[item] + (index < packages.length - 1 ? ' و ' : " ")
    })
    return 'برای تمدید بسته‌های ' + tempStr
}
const DiscountCard = (props) => {
    const copy = async (text) => {
        await navigator.clipboard.writeText(text);
    }
    return (
        <div className={style.wrapper}>
            <div className={style.rightCol}>

                {props.data.amountType === 'percent' ? <React.Fragment>
                        <p className={style.pbold}>
                            <div className={style.pThinner}> %</div>
                            {" " + toPersianNumber(props.data.amount)}</p>
                    </React.Fragment> :
                    <React.Fragment>
                        <p className={style.pbold}>{toPersianNumber(numberWithCommas(props.data.amount))}</p>
                        <p className={style.pThinner}>تومان</p>
                    </React.Fragment>
                }


            </div>
            <div className={style.leftCol}>
                <div className={style.row}>
                    <div className={style.titleRow}>
                        <div className={style.label}> :کد تخفیف</div>
                        <div className={style.name}>{props.data.code}</div>
                        <div className={style.copyButton} onClick={() => copy('blahhh')}>#</div>
                    </div>
                </div>
                <div className={style.info}>
                    {props.data.packages[0] !== '*' &&
                        <React.Fragment>
                            {packagesNames(props.data.packages)}
                            <div className={style.icon}>h</div>
                        </React.Fragment>
                    }
                </div>
                <div className={style.row}>
                    <div
                        className={style.expireDate}>{'مدت اعتبار تا ' + toPersianNumber(moment(props.data.endTime).format('jYYYY/jMM/jDD'))}</div>
                    <div className={style.submitCodeButton} onClick={() => props.submitDiscount(props.data.code)}>اعمال
                        کد تخفیف
                    </div>
                </div>
            </div>
        </div>
    )

}

export default DiscountCard;
